import { SESSION_TYPES } from './constants.js';

const isPermanentSession = ({ scheduledAt, type }) =>
  type === SESSION_TYPES.MEETING && !scheduledAt;

export default isPermanentSession;
